module.exports = __webpack_public_path__ + "static/media/individual.b3529350.svg";